import { DOCUMENT } from '@angular/common';
import {
  Directive,
  EventEmitter,
  HostListener,
  Inject,
  Output,
} from '@angular/core';

@Directive({
  selector: '[rdClickOutside]',
})
export class ClickOutsideDirective {
  @Output()
  public rdClickOutside = new EventEmitter<MouseEvent>();

  private clickedInside = false;

  constructor(@Inject(DOCUMENT) protected document: Document) {}

  @HostListener('click')
  detectInsideClick(): void {
    this.clickedInside = true;
  }

  // Best case to illustrate this is nexus-tc-date-range-input (a component which has rdClickOutside but
  // has a mat-select inside of it. MatSelect will create a cdk-overlay-container AFTER rd-main-container.
  // And the browser will detect a click on the outside of this host element, but the user just clicked the
  // overlay. We categorise this as "the user still clicked on the host element" because otherwise,
  // (rdClickOutside) would emit.
  @HostListener('document:click', ['$event'])
  detectOutsideClick(event: MouseEvent): void {
    const clickedOnMatSelectOverlay = this.document
      .querySelector('.cdk-overlay-container')
      ?.contains(event.target as Node);

    if (!this.clickedInside && !clickedOnMatSelectOverlay) {
      this.rdClickOutside.emit(event);
    }
    this.clickedInside = false;
  }
}
